"use client";

type PartySizeFieldProps = {
  value?: number;
  onChange: (size: number) => void;
  required?: boolean;
  error?: string;
  maxSize?: number;
};

export function PartySizeField({ value, onChange, required, error, maxSize = 20 }: PartySizeFieldProps) {
  return (
    <div>
      <label className="block text-sm font-medium mb-1">
        Party Size {required && <span className="text-destructive">*</span>}
      </label>
      <input
        type="number"
        min={1}
        max={maxSize}
        value={value || ""}
        onChange={(e) => onChange(parseInt(e.target.value) || 1)}
        required={required}
        className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
        placeholder="Number of guests"
      />
      {error && <p className="mt-1 text-sm text-destructive">{error}</p>}
    </div>
  );
}
